import { DataLayer } from "@grandvisionhq/analytics";
import { mapProductListingToDataLayerProductObject } from "../../../Mappers/DataLayer/Mappers/ProductListingMapper.js";
const createImpressionEvent = (currency) => {
  return {
    event: "gvProductImpressions",
    atfEcommerce: {
      ecommerce: {
        currencyCode: currency,
        // ISO4217
        impressions: []
      }
    }
  };
};
const createImpressionObject = (product, position) => ({
  ...mapProductListingToDataLayerProductObject(
    DataLayer.DataLayerTypes.PurchaseType.OneTime,
    product,
    product.masterVariant.sku || "undefined"
  ),
  list: `category: ${product.productType}`,
  position
});
const createInteractionEvent = (product, position, location, currency) => {
  return {
    event: "gvProductClick",
    atfEcommerce: {
      ecommerce: {
        currencyCode: currency,
        // ISO4217
        click: {
          actionField: { list: location },
          products: [
            {
              ...mapProductListingToDataLayerProductObject(
                DataLayer.DataLayerTypes.PurchaseType.OneTime,
                product,
                product.masterVariant.sku || "undefined"
              ),
              position
            }
          ]
        }
      }
    }
  };
};
export {
  createImpressionEvent,
  createImpressionObject,
  createInteractionEvent
};
//# sourceMappingURL=ProductListingPageEvents.js.map
